import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
export const UiIconYandex = (props) => (_jsx(SvgIcon, Object.assign({}, props, { children: _jsx("path", { d: "M14.8,5.8h-1.3c-2.3,0-3.6,1.2-3.6,3c0,2,0.9,3,2.6,4.2l1.4,1l-4.2,6.4H6.7l3.7-5.7C8.3,13.2,7.1,11.6,7.1,9\n\tc0-3.3,2.2-5.5,6.4-5.5h4.2v17h-2.9V5.8z" }) })));
//# sourceMappingURL=ui_icon_yandex.js.map